<template>
  <section class="vision">
    <img class="icon" src="@/assets/icon-vision-1.png" />
    <div class="slogan">
      <label> 願景 </label>
      成為國人珍惜的教育品牌
    </div>
    <img class="icon" src="@/assets/icon-vision-2.png" />
    <div class="slogan">
      <label class="yellow"> 核心價值 </label>
      關懷、誠信、尊重、品質
    </div>
    <img class="icon" src="@/assets/icon-vision-3.png" />
    <div class="slogan">
      <label> 使命 </label>
      陪伴孩子成就夢想
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.vision {
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(3, 56px fit-content(330px));
  grid-gap: 8px;
  padding: 0 0 30px 0;
  border-bottom: 3px solid #63abcd;
  @media (max-width: 820px) {
    grid-template-columns: 56px fit-content(230px);
    border-bottom: none;
    padding-bottom: 0;
  }

  .icon {
    height: 56px;
    width: 56px;
    margin: auto;
  }
  .slogan {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #1c2e53;
    @media (max-width: 1140px) {
      margin-right: 20px;
      flex-direction: column;
      align-items: start;
    }
    @media (max-width: 480px) {
      font-size: 12px;
    }
    label {
      font-size: 26px;
      color: #63abcd;
      &.yellow {
        color: #c4cb7a;
      }
      margin-right: 14px;
    }
  }
}
</style>
